export default function () {
  this.internalImageData = null
  this.$emit('input', '')
}
